import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FopModeService } from '../../../../client/app/fop-mode/fop-mode.service';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { AuthenticationService } from '../../authentication/authentication.service';
import { IMenuItem } from '../navigation.model';
import { NavigationService } from '../navigation.service';
import { EnvService } from './../../configuration/env.service';

@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit, OnDestroy {
    mainMenuItems: IMenuItem[];
    sideMenuItems: IMenuItem[];
    userName: string;
    projectName: string;
    projectVersion: string;

    private subLocationContextChanges: Subscription;
    private subFopConfig: Subscription;

    constructor(
        private readonly navigationService: NavigationService,
        private readonly authenticationService: AuthenticationService,
        private readonly locationContextService: LocationContextService,
        private readonly fopModeService: FopModeService,
        private readonly env: EnvService
    ) {}

    ngOnInit() {
        this.loadMenuItems();
        this.subLocationContextChanges = this.locationContextService.locationContextChanges$.subscribe(() =>
            this.loadMenuItems()
        );

        this.userName = this.authenticationService.getUsername();
        this.subFopConfig = this.fopModeService
            .getFopConfig()
            .subscribe(
                fopConfig =>
                    (this.projectName = fopConfig.fopModeEnabled ? 'Fixed Operator Panel' : 'Mobile Operator Panel')
            );
        this.projectVersion = this.env.config.version;
    }

    loadMenuItems() {
        this.mainMenuItems = this.navigationService.getMainMenuItems();
        this.sideMenuItems = this.navigationService.getSideMenuItems();
    }

    hasSideMenuItems(): boolean {
        return this.sideMenuItems.length > 0;
    }

    ngOnDestroy() {
        if (this.subLocationContextChanges) {
            this.subLocationContextChanges.unsubscribe();
        }
        if (this.subFopConfig) {
            this.subFopConfig.unsubscribe();
        }
    }
}
